import React from "react";
import "./FAQComponent.css";
import call from "../../images/call.png"
import mail from "../../images//mail.png"
import Accordion from 'react-bootstrap/Accordion';

const FAQComponent2 = () => {
  return (
    <section className="faq_pg_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="faq_pg_title_outer">
              <div className="classes_workshop_title_outer m-auto text-center">
                <div className="smal_title smal_mid">
                  <h5>Have You Question in Mind?</h5>
                </div>
                <div className="classes_workshop_title">
                  <h2>Frequently Asked Questions</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="faq_pg_box_1 d-flex">
        <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                  <h5>I'm not fit - can I do yoga?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                  <h5>What should I wear?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                  <h5>What if I am late for a class?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                  <h5>Can I Do a Work Exchange for Your Course?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                  <h5>What is the Purpose of Sun Salutations?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                  <h5>What is Yoga Teacher Training Certification?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                  <h5>Can You Brief Me About the Weather of Rishikesh?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>
                  <h5>Are You Registered With Yoga Alliance?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
        
          <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                  <h5>What should I bring to class?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                  <h5>Do I need a yoga mat?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                  <h5>How Many Times a Week Should I Practice?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                  <h5>Which Yoga Poses Can I Do at My Desk?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                  <h5>Do I Need to Attend Any Exams?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                  <h5>What Type of Visa I Need to Get in India?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                  <h5>Can I Do a Work Exchange for Your Ttc Course?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>
                  <h5>I'm not flexible - can I do yoga?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
          
          <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                  <h5>I'm not fit - can I do yoga?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                  <h5>How Do I Pay for Classes?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                  <h5>What Are the Best Poses For the Morning?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                  <h5>Is There Any Facility Use Internet at the Centre?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                  <h5>Do You Have Any Dress Code for the Yoga School?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                  <h5>English is Not Language. Will It Be a Problem for Me?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                  <h5>How Do I Reserve a Spot?</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy abd text ever since. dummy text of the
                    printing and typesetting
                  </p>
                  </Accordion.Body>
                </Accordion.Item>
               
              </Accordion>
         
        </div>
        <div className="faq_bottom_title text-center faq_pg">
          <h4>Did Not Find Your Answer?</h4>
          <div className="faq_bottom_title_box d-flex justify-content-between">
            <div className="faq_call_outer first d-flex">
              <div className="faq_call">
                <img src={call} alt="call" />
              </div>
              <div className="faq_call_detail">
                <p>
                  <a href="tel:+44 123 456 7890" className="number_faq">
                    <span className="call_us">Call Us on</span> +44 123 456 7890
                  </a>
                </p>
              </div>
            </div>
            <div className="faq_call_outer  d-flex">
              <div className="faq_call">
              <img src={mail} alt="call" />
              </div>
              <div className="faq_call_detail">
                <p>
                  <a href="mailto:trooyoga@email.com">
                    <span className="email_us">Email Us on</span>trooyoga@email.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQComponent2;
